import { render } from "./TabAccordion.vue?vue&type=template&id=23b215f4"
import script from "./TabAccordion.vue?vue&type=script&lang=js"
export * from "./TabAccordion.vue?vue&type=script&lang=js"

import "./TabAccordion.vue?vue&type=style&index=0&id=23b215f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__